import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Stack,
  TextField,
} from '@mui/material'
import { Control, Controller } from 'react-hook-form'
import { LoginFormValues } from '../types'

type LoginFormProps = {
  domain: string
  control: Control<LoginFormValues>
  isChangePassword: boolean
  setChangePassword: (isChange: boolean) => void
  onLogin: () => Promise<void>
}
export const LoginForm = ({
  domain,
  control,
  isChangePassword,
  setChangePassword,
  onLogin,
}: LoginFormProps) => {
  return (
    <Box component="form" noValidate paddingX={1} onSubmit={onLogin}>
      <FormGroup>
        <Controller
          control={control}
          name="email"
          render={({ field, formState: { errors } }) => (
            <>
              <InputLabel
                size="small"
                style={{ marginBottom: 8 }}
                error={!!errors.email}
              >
                メールアドレス
              </InputLabel>
              <TextField
                {...field}
                placeholder="メールアドレス"
                variant="outlined"
                margin="normal"
                size="small"
                onChange={field.onChange}
                required
                error={!!errors.email}
                helperText={errors.email?.message}
                fullWidth
                autoFocus
              />
            </>
          )}
        />
        <Controller
          control={control}
          name="password"
          render={({ field, formState: { errors } }) => (
            <>
              <InputLabel
                size="small"
                style={{ marginBottom: 8 }}
                error={!!errors.password}
              >
                パスワード
              </InputLabel>
              <TextField
                {...field}
                onChange={field.onChange}
                placeholder="パスワード"
                type="password"
                variant="outlined"
                margin="normal"
                size="small"
                autoComplete="password"
                error={!!errors.password}
                helperText={errors.password?.message}
                required
                fullWidth
              />
            </>
          )}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChangePassword}
              size="small"
              onChange={(ev) => setChangePassword(ev.target.checked)}
            />
          }
          label="パスワード変更"
        />
      </FormGroup>

      <Stack direction="column" spacing={1} sx={{ mt: 3 }}>
        <Button type="submit" fullWidth variant="contained">
          ログイン
        </Button>
        <Button fullWidth variant="outlined" href={`/${domain}/request`}>
          ユーザー登録
        </Button>
      </Stack>
    </Box>
  )
}
